"use strict";
exports.__esModule = true;
exports.generateSegmentId = void 0;
// https://github.com/busbud/napi/blob/master/apps/grand-central/models/js/x-departure.js#L431-L433
function djb2(string) {
    var hash = 5381;
    // Apparently iterating backwards over a string is faster in JavaScript.
    var i = string.length;
    while (i) {
        hash = (hash * 33) ^ string.charCodeAt(--i);
    }
    // JavaScript does bitwise operations on signed integers. This casts the hash
    // to an unsigned integer so we always get a positive result.
    return hash >>> 0;
}
function djb2HashObject(object) {
    return djb2(JSON.stringify(object)).toString(16);
}
/**
 * Creates a hash of critical segment properties suitable for use as the `segment.id`.
 * @param segment
 */
function generateSegmentId(source_name, segment) {
    var _a;
    return djb2HashObject({
        source_name: source_name,
        operator: segment.operator.xid,
        // Since we get timestamps as either local (adapters) or internationalized (PS), generate the segment ID from the base timestamp
        // which should be the same regardless
        departure_time: segment.departure_time.timestamp.slice(0, 19),
        arrival_time: (_a = segment.arrival_time) === null || _a === void 0 ? void 0 : _a.timestamp.slice(0, 19),
        // XIDs used here as the regular ID can change if the stop is remapped
        origin: segment.origin.xid,
        destination: segment.destination.xid,
        "class": segment["class"].xid,
        fare: segment.fare.xid,
        search_origin: segment.search_origin.xid,
        search_destination: segment.search_destination.xid
    });
}
exports.generateSegmentId = generateSegmentId;
